import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref, watch, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import { TableOpt } from '@/components/cmTable/types'
import { TerminalViewService, DetailQueryParams } from './terminal-view/terminal-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'popup-detail-list',
  props: {
    deviceId: {}
  },
  setup(__props: any, { expose: __expose }) {

const { t } = useI18n()
const popupTypeDict = computed(() => ['', t('popupIntercept.filterBottomRightBubble'), t('popupIntercept.filterCenterBubble'), t('popupIntercept.filterBundledSoft')])

const props = __props

const injector = useReflectiveInjector([TerminalViewService])
const terminalViewService = injector.get(TerminalViewService)
const dataApi = terminalViewService.fetchDetailList.bind(terminalViewService)

const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
const queryParams = reactive<DetailQueryParams>({
  page: 1,
  limit: 20,
  sort: '',
  asc: false,
  device_id: props.deviceId || ''
})

const tableOpt = computed<TableOpt>(() => ({
  bodyStyle: 'padding: 10px 16px',
  columns: [
    { prop: 'soft_name', label: t('popupIntercept.softName'), columnOpt: { minWidth: 150 } },
    {
      prop: 'popup_type',
      label: t('popupIntercept.popupType'),
      formatter: (_row, val) => popupTypeDict.value[val] || '--',
      columnOpt: { minWidth: 120 }
    },
    { prop: 'intercept_count', label: t('popupIntercept.interceptCount'), columnOpt: { minWidth: 100 } },
    { prop: 'popup_count', label: t('popupIntercept.popupIssue'), columnOpt: { minWidth: 100 } },
    {
      prop: 'latest_popup_time',
      label: t('popupIntercept.recentInterceptTime'),
      sortable: 'custom',
      formatter: (_row, val) => val ? new Date(val * 1000).toLocaleString() : '--',
      columnOpt: { minWidth: 160 }
    }
  ],
  rowKey: 'soft_id',
  path: 'list',
  height: '100%'
}))

watch(() => props.deviceId, async(newDeviceId) => {
  queryParams.device_id = newDeviceId || ''
  queryParams.page = 1
  await refreshList()
}, { immediate: true })

__expose({
  tableRef
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    firstLoading: false,
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    }
  }, null, 8, ["tableOpt", "api", "modelValue"]))
}
}

})